$(function () {
   console.log('Hello World'); 
   if (window.location.hash === '#jscViewSpecs') {
      expandFindInStore();
    }
});
viewSpecs = () =>{
 
   var anchr = $('#jscViewSpecs').parent();
  
    if (anchr.length > 0) {
     $('html').animate({
         scrollTop: $("#jscViewSpecs").offset().top - 168
     }, 1000);

    }
  
  } 

  // START AUTOPLAY VIDEO SECTION
  
  document.addEventListener('DOMContentLoaded', function() {
    // Find all video sections
    var videoSections = document.querySelectorAll('.vvideo');

    // Loop through each video section
    videoSections.forEach(function(section) {
        // Find the autoplay video iframe within this section
        var autoplayIframe = section.querySelector('.autoplay-video');

        // If an autoplay video iframe is found, start autoplay
        if (autoplayIframe) {
            // Autoplay the video by replacing the iframe source
            autoplayIframe.src = autoplayIframe.getAttribute('data-src');
            autoplayIframe.parentNode.classList.add('is-playing');
        }
    });
});
// END AUTOPLAY VIDEO SECTION

//start: refresh page
refreshPage = () => {
    setTimeout(function(){
        location.reload();
    },500);
    
}
//end: refresh page

//start: update pricing table in pdp
jscUpdatePricingTable = (e) => {
    var $pricingTable = $('.vol-pricing_table');
    
    setTimeout(function(){
        var $url = window.location.href;
        var $splitUrl = $url.split("variant=");
        var $getVarID = $splitUrl[1];
        $pricingTable.find('ul').empty(); // delete the content of the table
        // console.log($url,$getVarID);

        $('.jsc-variant-vol-pricing .jsc-each-var-vol-pricing').each(function(){
            var $thisId = $(this).attr('data-var-id');

            if ($thisId == $getVarID) { // get only the pricing of variant that match the selected variant
                
                $(this).children().each(function(){
                    var $thisSeq = $(this).attr('data-seq');
                    var $thisSeqQty = $(this).attr('data-min-qty');
                    var $thisSeqPrice = $(this).attr('data-price');
                    // console.log($thisSeq,$thisSeqQty,$thisSeqPrice);

                    //start: create new table content
                    var html = '<li class="jsc-vol-pricing-list" data-seq="' + $thisSeq + '">' + 
                                '<span class="volume_pricing">' + $thisSeq + '</span>' + 
                                    '<span class="quantity">' + $thisSeqQty + '<a aria-hidden="true">+</a></span>' +
                                    '<span class="pricing">' + $thisSeqPrice + '</span>' +
                                    '</li>';
                    $pricingTable.find('ul').append(html);
                     //end: create new table content

                });
            }
        });
    },300);
}
//end: update pricing table in pdp